module.exports = __webpack_public_path__ + "img/product_02.f264abe.png";